import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setModalBuyTicket } from "@/app/modal/actions";
import { useState, useEffect } from "react";
import LuckyDrawTicket from "@/assets/images/lottery-ver2/lucky-draw-ticket.png";
import useGetBalanceOpv from "@/hooks/useGetBalanceOpv";
import useLuckyDrawTicket from "@/hooks/useLuckyDrawTicket";
import { useToasts } from "react-toast-notifications";
import { hideLoading, showLoading } from "@/components/common/loading/store/slice";
import "./styles.scss";

const ModalBuyTicket = () => {
  const dispatch = useDispatch();
  const { modalBuyTicket } = useSelector((state: any) => state.modal);
  const { addToast } = useToasts();
  const {
    handleTicketPurchase,
    checkAllowance,
    isApproving,
    ticketPrice
  } = useLuckyDrawTicket(modalBuyTicket?.toggle);
  const [quantity, setQuantity] = useState(1);
  const [opvBalance] = useGetBalanceOpv();
  const [isLoading, setIsLoading] = useState(false);
  const [isCheckingApproval, setIsCheckingApproval] = useState(false);

  const handleCancel = () => {
    dispatch(setModalBuyTicket({ toggle: false, data: {} }));
  };
  const handleBuyNow = async () => {
    if (!modalBuyTicket?.data?.roundId) {
      addToast("Missing round data", { appearance: "error" });
      return;
    }

    setIsLoading(true);
    dispatch(showLoading());

    try {
      await handleTicketPurchase(quantity, modalBuyTicket.data.roundId);
    } catch (error: any) {
      addToast(`Purchase failed: ${error?.message || "Unknown error"}`, {
        appearance: "error",
      });
    } finally {
      setIsLoading(false);
      dispatch(hideLoading());
    }
  };

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity >= 1) {
      setQuantity(newQuantity);
    }
  };

  // const loadTicketPriceOnOpen = useCallback(async () => {
  //   if (!modalBuyTicket?.toggle) return;

  //   try {
  //     await loadTicketPrice();
  //   } catch (error) {
  //     console.error("Error loading ticket price:", error);
  //   }
  // }, [modalBuyTicket?.toggle, loadTicketPrice]);

  const checkApprovalStatus = async () => {
    if (!ticketPrice || ticketPrice === "0") return;

    setIsCheckingApproval(true);
    try {
      const totalAmount = parseFloat(ticketPrice) * quantity;
      await checkAllowance(totalAmount);
    } catch (error) {
      console.error("Error checking approval:", error);
    } finally {
      setIsCheckingApproval(false);
    }
  };

  const pricePerNFT = ticketPrice && ticketPrice !== "0" ? parseFloat(ticketPrice) : (modalBuyTicket?.data?.ticketPrice || 2);
  const totalPrice = pricePerNFT * quantity;
  const availableBalance = Number(opvBalance || 0);


  useEffect(() => {
    if (modalBuyTicket?.toggle) {
      setQuantity(1);
    }
  }, [modalBuyTicket?.toggle]);

  useEffect(() => {
    if (modalBuyTicket?.toggle && ticketPrice && ticketPrice !== "0") {
      checkApprovalStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity, ticketPrice, modalBuyTicket?.toggle]);

  return (
    <Modal
      title="Checkout"
      visible={modalBuyTicket?.toggle}
      onCancel={handleCancel}
      className="modal-buy-ticket"
      footer={false}
      width={360}
      centered
      style={{ top: 20 }}
    >
      <div className="pt-4 flex flex-col gap-5">
        <div className="flex items-center mb-4 gap-4">
          <img src={LuckyDrawTicket} alt="Ticket" width={48} height={48} />
          <div>
            <span className="text-base font-bold text-md">Ticket</span>
            <p className="text-sm text-gray-600">
              Round LD-{String(modalBuyTicket?.data?.roundNumber || modalBuyTicket?.data?.round?.roundNumber || 1).padStart(3, '0')}
            </p>
            {modalBuyTicket?.data?.round?.status && (
              <p className="text-xs text-blue-600 capitalize">
                Status: {modalBuyTicket.data.round.status}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <span className="text-base font-bold">Ticket Price:</span>
            <span className="text-base">
              {ticketPrice || pricePerNFT} MBC
            </span>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-base font-bold">Quantity:</span>
            <div className="flex items-center justify-between input-quantity">
              <button
                onClick={() => handleQuantityChange(quantity - 1)}
                className="minus-btn "
              >
                -
              </button>
              <input
                type="number"
                className="text-base font-bold quantity-input"
                value={quantity === 0 ? "" : quantity}
                min={1}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    setQuantity(0);
                  } else {
                    const num = parseInt(value, 10);
                    if (!Number.isNaN(num) && num >= 0) {
                      setQuantity(num);
                    }
                  }
                }}
              />
              <button
                onClick={() => handleQuantityChange(quantity + 1)}
                className="plus-btn"
              >
                +
              </button>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-base font-bold">Total amount:</span>
            <span className="text-base">
              {totalPrice} MBC
            </span>
          </div>
        </div>

        <div className="text-center mt-2">
          {availableBalance >= totalPrice ? (
            <button
              onClick={handleBuyNow}
              disabled={isApproving || isLoading || isCheckingApproval}
              className="w-full h-11 bg-[#2750FB] text-white border-none rounded-md text-base font-bold cursor-pointer mb-2 uppercase tracking-wider disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isApproving ? "Approving..." : isLoading ? "Processing..." : "BUY NOW"}
            </button>
          ) : (
            <button
              disabled
              className="w-full h-11 bg-[#2750FB] text-white border-none rounded-md text-base font-bold cursor-not-allowed mb-2 opacity-60"
            >
              INSUFFICIENT MBC BALANCE
            </button>
          )}

          <div className="availableBalance text-xs mt-2">
            Available: {Number(availableBalance).toLocaleString()} MBC
          </div>

        </div>
      </div>
    </Modal>
  );
};

export default ModalBuyTicket;
